import React, { useState } from "react";
import { ConnectedProps } from "react-redux";
import BEMHelper from "react-bem-helper";

// Elements
import { Button } from "bokamera-embedded-ui";
import ShowMoreText from "@/components/elements/ShowMoreText";

import { Article as ArticleType, Currency, ServiceType } from "@/types";

import "./BoughtArticle.css";
import { Trans } from "@lingui/macro";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { selectArticle } from "@/reducers/article";
import ArticleDetails from "./ArticleDetails";

interface OwnProps {
  article: ArticleType;
  hideSelect?: boolean;
  append?: React.FC<ServiceType>;
  compact?: boolean;
}

const c = new BEMHelper({
  name: "Article",
});

const Article: React.FC<OwnProps> = ({ article, hideSelect = false }) => {
  const configuration = useAppSelector((s) => s.configuration.data);
  const company = useAppSelector((s) => s.company.data);

  return company ? (
    <div {...c()} data-testid={`article-id-${article.Id}`}>
      <ArticleDetails
        article={article}
        company={company}
        configuration={configuration}
        hideSelect={hideSelect}
      />
    </div>
  ) : null;
};

export default Article;
